import { azureFetch } from "./azureFetch";


export const fetchCmlDetails = async (id) => {
    try {
        const response = await azureFetch('cml', { "id": id });
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor data:", error);
        throw error;
    }
};



export const fetchCmlInfo = async (id) => {
    try {
       const response = await azureFetch('cml/details', { "id": id });
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor data:", error);
        throw error;
    }
};

